<template>
  <v-app>
    <v-main >
      <v-container fluid fill-height  >
        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card>
            <v-card-title class="text-h5">
              {{ $t('alertas.titulodatos') }}
            </v-card-title>
            <v-card-text>{{ $t('alertas.nuevalista') }}</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>
        <v-dialog v-model="dialogdelete" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">Desea eliminar esta Persona?</v-card-title>
            <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="close">No</v-btn>
              <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

           <v-row align="center"  justify="center">
             <v-col cols="12" lg="8">
        <v-card> <v-card-title> <v-row align="center" class="text-center">
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-img width="270px" :src="logo270"></v-img>
            </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
              <h1  class="display-1 font-weight-bold">
              Hola {{titulonegocio}}
              </h1>
            <p style="font-size: medium; text-align: justify; word-break: normal;">
              Bienvenido, en este link puedes ingresar a tus invitados para tu reserva a {{reserva.espacioNegocio.zonaNegocio.negocio.negocio}}, lo unico que debes hacer es ingresar los nombres de tus invitados y serán agregados a la lista. Si necesita mas nombres comunicate con nosotros.
            </p>
            </v-col>
          </v-row></v-card-title>
          <v-card-text>
          <v-row   justify="space-between">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-form  ref="form">
                <v-row>

                  <v-col cols="12" sm="12" md="12">
                      <v-textarea v-model="nombres" @change="vernombres" auto-grow rows="6" outlined placeholder="COPIA Y PEGA LOS NOMBRES"></v-textarea>
                  </v-col>

                </v-row>
                <v-row>
                  <v-col>
                    <p>Cantidad Maxima en esta Reserva :  {{cantmax.cantidadmaxima}}</p>
                    <p>Cantidad en Lista ingresados: {{cantmax.cantidadactual}}</p>
                    <p>Posibles :{{cantmax.posibles}}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-alert
                        :value="alerterror"
                        color="red"
                        dark
                        dismissible
                        border="top"
                        transition="scale-transition"
                    >
                      {{texterror}}
                    </v-alert>
                    <v-btn  :disabled="botn"  @click="save">Grabar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
          </v-card-text>
        </v-card></v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12" lg="8">
          <v-data-table
              :headers="headers"
              :items="listas"
              class="elevation-1"
              :items-per-page="cantmax.cantidadmaxima"
              disable-pagination
              hide-default-footer
              no-data-text="No hay datos disponibles para mostrar."
              no-results-text="No hay resultados para la búsqueda."
              loading-text="Cargando... Por favor espere."
              style="background-color: #393E46;"
          >
            <template v-slot:[`item.action`]="{ item }">

              <v-tooltip v-if="!item.ingreso" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      small
                      class="mr-2"
                      color="error"
                      v-bind="attrs"
                      v-on="on"
                      @click="deleteItem(item)"
                  >
                    fas fa-minus-circle
                  </v-icon>
                </template>
                <span>Borrar de la Lista</span>
              </v-tooltip>
            </template>
          </v-data-table>
          </v-col>
        </v-row>

        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import moment from "moment";
export default {
  name: "listareserva",
  title:"Lista Reserva",
  components: {

  },

  data () {
    return {
      codigo: '',
      overlay: false,
      alertnuevo: false,
      logoexist: false,
      logo270:'',
      logoimg: null,

      botn: false,
      cantidad: 0,
      cantmax: {
        cantidadmaxima: '',
        cantidadactual: '',
        posibles: ''
      },
      maximo: 0,
      progr:false,
      mostrarlista:true,
      nombres:'',
      fiestaId:0,
      tipoListaId:0,
      search: '',
      editedIndex: -1,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Codigo para Registro', value: 'codigoUnico'},
      ],
      reserva:{},
      dialogdelete: false,
      alerterror:false,
      texterror:'',
      activopr:true,
      listas:[],
      lista:{},
      editedItem: {
        id:0,
        listaFiesta:{
          id:0,
          titular:'',
          promotor:{},
          tipoLista:{},
          fiesta:{},
          createdAt: '2020-01-01 00:00:00'
        },
        nombre:'',
        codigoUnico:'',
        personaId:0,
        fechaIngreso:null,
        f:false,
        createdAt: '2020-01-01 00:00:00'
      },

    }
  },

  mounted (){
    this.codigo =  this.$route.params.codigo;
    if(this.codigo === undefined){
      this.$router.push({ path: '/' });
    }else{
      this.damereserva();
    }
  }
,

  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    borralo (){
      this.overlay = true
      this.dialogdelete = false;
      axios
          .delete('lista/'+ this.listas[this.editedIndex].codigoUnico,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);

            this.alertborrador = true;
            this.dameMaximos();
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false
          });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    save () {
      this.overlay = true;
      this.vernombres()
      var bodyFormData = new FormData();
      bodyFormData.append("reservaCodigo",this.codigo);
      bodyFormData.append("nombres",this.nombres);
      axios
          .post('lista/fiesta/reserva/nuevo',bodyFormData).then(response => {
        this.listas=response.data
        this.mostrarlista = false
            this.alertnuevo = true;
        this.overlay = false;
        this.$refs.form.reset()
      })
          .catch(error => {
            this.error = "Hubo un error";
            this.overlay = false;
            console.log(error);
          });
    },
    vernombres(){
      let maximo = this.cantmax.posibles;
      var arraycad = this.nombres.split(/\r?\n/)
      this.nombres = ""
      var nmb = 0;
      if(arraycad.length< maximo){
        nmb = arraycad.length
      }else{
        nmb = maximo
      }

      for(let i=0;i<nmb;i++){
        if(i === nmb-1){
          this.nombres = this.nombres + arraycad[i]
        }else{
          this.nombres = this.nombres + arraycad[i] + "\r\n"

        }
      }
      if(arraycad.length> maximo){
        this.texterror="Su lista sobrepasa la cantidad de nombres permitida, se recorto a lo posible"
        this.alerterror = true
      }
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },
    dameMaximos(){
      let urlfiesta = 'reservas/xfiesta/maximos/'+this.reserva.id;
        this.overlay = true

        axios
            .get(urlfiesta)
            .then(response => {
              this.cantmax = response.data;
              this.maximo = this.cantmax.posibles
              this.overlay = false;
              this.damelistas();
            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false;
            });

    },

    formatDarete (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD HH:mm:ss")
    },
    damereserva(){
      this.overlay = true;
      axios
          .get('reservas/xfiesta/'+this.codigo)
          .then(response => {
            this.reserva = response.data;
            this.titulonegocio = this.reserva.reserva
            this.logo270 = this.reserva.espacioNegocio.zonaNegocio.negocio.logo270
            this.overlay = false
            this.dameMaximos()

          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    },
    damelistas(){
      this.overlay = true;
      axios
          .get('reservas/listas/fiesta/'+this.codigo)
          .then(response => {
            this.listas = response.data;
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    },

  }
}
</script>

<style scoped>

</style>